import { ARIValues, DailySet, ValueTypes } from "../../shared/types";
import { AriType } from "../../updateForm";

export class Complement implements ARIValues {
  ticker: string;
  dailySet: DailySet[];
  valueType: ValueTypes;
  type: AriType;

  private constructor(
    ticker: string,
    dailySet: DailySet[],
    valueType: ValueTypes
  ) {
    this.ticker = ticker;
    this.dailySet = dailySet;
    this.valueType = valueType;
    this.type = AriType.COMPLEMENTS;
  }

  static of(ticker: string, dailySet: DailySet[]): Complement {
    return new Complement(ticker, dailySet, ValueTypes.rate)
  }
}
